import { FaQuoteLeft, FaFacebook, FaInstagram } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import { Col, Container, Form, FormGroup, Row } from "react-bootstrap";
import author from "../../../assets/images/course/author.jpg";
import course from "../../../assets/images/course/course-detail.png";
import { FaLinkedin, FaXTwitter } from "react-icons/fa6";
import DOMPurify from "dompurify";

const BlogDetail = () => {
  const [blog, setBlog] = useState(null);
  const [imagePath, setImagePath] = useState("");
  const [bgImage, setBgImage] = useState("");
  const blogId = localStorage.getItem("selectedBlogId");
  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/blog-edit`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ id: blogId }),
          }
        );
        const data = await response.json();
        setBlog(data.data);
        setImagePath(data.imagePath);
        if (data.status === 1) {
          setBlog(data.data);
          setImagePath(data.imagePath);
        } else {
          console.error("Failed to load blog data");
        }
      } catch (err) {
        console.error("Error fetching blog:", err);
      }
    };

    if (blogId) {
      fetchBlogDetail();
    }
  }, [blogId]);
  const decodeHTML = (html) => {
    const parser = new DOMParser();
    const decoded = parser.parseFromString(html, "text/html");
    return decoded.documentElement.textContent;
  };

  useEffect(() => {

    bannerimg();

  }, []);
  const bannerimg = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
      );

      const baseUrl = res.data.imagePath;
      const courseImage = res.data.home_setting[0]?.course_image;

      // Full image URL
      const fullUrl = baseUrl + courseImage;

      setBgImage(fullUrl);
    } catch (error) {
      console.error("Error fetching banner:", error);
    }
  };
  return (
    <>
      <section className="course">
        <div className="page_header"></div>
        <div className="rs-breadcrumbs breadcrumbs-overlay">
          <div className="breadcrumbs-img">
            <img src={bgImage} alt="Breadcrumbs bg" />
          </div>
          <div className="breadcrumbs-text white-color">
            <h1 className="page-title">Blog Detail</h1>
          </div>
        </div>
        <Container>
          <div className="blog_detail py-60">
            <Row>
              {/* Author & Info */}
              <Col lg={12}>
                <div className="blog_top d-flex gap-0 gap-md-5">
                  <div className="">
                    <div className="about_blog_row mb-24 d-flex justify-content-between">
                      <div className="author_block d-flex align-items-center gap-2">
                        {/* <img
                      src={
                        blog?.auth_image
                          ? `${imagePath}${blog.auth_image}`
                          : author
                      }
                      alt="Author"
                    /> */}
                        <div>
                          <p className="mb-4p">Author:</p>
                          <h6>{blog?.auth_name || "Unknown Author"}</h6>
                        </div>
                      </div>
                      <div>
                        <p className="mb-4p">Published Date</p>
                        <h6>{blog?.date || ""}</h6>
                      </div>
                      <div>
                        <p className="mb-4p">Category</p>
                        <h6>{blog?.title || ""}</h6>
                      </div>
                    </div>

                    <div className="tags mb-24">
                      {["#education", "#learning", "#latest", "#teachers"].map(
                        (tag, i) => (
                          <span key={i} className="h6 me-2">
                            {tag}
                          </span>
                        )
                      )}
                    </div>

                    <h2 className="mb-16">
                      {/* Remote Learning Tips: Thrive in Online Classes */}
                      {blog?.title || ""}
                    </h2>
                    {/* <h2 className="mb-16">{blog?.title || ""}</h2> */}
                  </div>

                  <div>
                    <img className="br-20 mb-24"
                      src={blog?.image ? `${imagePath}${blog.image}` : course}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = course;
                      }}
                      alt={blog?.title || "Blog Image"}
                    />
                  </div>
                </div>
              </Col>

              {/* Blog Image */}
              <Col lg={12}>
                <div
                  className="blog-description"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(blog?.description || ""),
                  }}
                ></div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
    </>
  );
};

export default BlogDetail;
